import React from 'react';
import { Loader2 } from 'lucide-react';

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  body: React.ReactNode;
  confirmLabel: string;
  confirmVariant?: 'destructive' | 'primary';
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmModal({ isOpen, title, body, confirmLabel, confirmVariant = 'destructive', loading, onConfirm, onCancel }: ConfirmModalProps) {
  if (!isOpen) return null;

  const confirmCls = confirmVariant === 'destructive'
    ? 'bg-red-600 hover:bg-red-700 text-white'
    : 'bg-fieldiq-accent hover:bg-amber-400 text-fieldiq-dark';

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4" onClick={e => { if (e.target === e.currentTarget) onCancel(); }}>
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title}
        className="bg-fieldiq-card border border-fieldiq-border rounded-2xl w-full max-w-md shadow-2xl animate-fade-in"
      >
        <div className="px-5 py-4 border-b border-fieldiq-border">
          <h3 className="text-lg font-bold text-white">{title}</h3>
        </div>
        <div data-testid="confirm-modal-body" className="px-5 py-4 text-sm text-fieldiq-text space-y-2">
          {typeof body === 'string' ? <p>{body}</p> : body}
        </div>
        <div className="flex gap-3 px-5 py-4 border-t border-fieldiq-border">
          <button onClick={onCancel} disabled={loading} className="flex-1 bg-fieldiq-dark border border-fieldiq-border text-white py-2.5 rounded-xl text-sm font-medium hover:border-fieldiq-muted transition-colors disabled:opacity-50">
            Cancel
          </button>
          <button onClick={onConfirm} disabled={loading} className={`flex-1 py-2.5 rounded-xl text-sm font-semibold transition-colors disabled:opacity-50 flex items-center justify-center gap-2 ${confirmCls}`}>
            {loading && <Loader2 size={14} className="animate-spin" />}
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
